import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-post-item',
  templateUrl: './post-item.component.html',
  styleUrls: ['./post-item.component.scss']
})
export class PostItemComponent implements OnInit {

  @Input() id: any;
  @Input() image: any;
  @Input() title: any;
  @Input() slug: any;
  @Input() summary: any;
  @Input() date: any;
  @Input() swiperEnabled: any = false;
  @Input() tagged: any;
  tag: string = '';

  constructor(private router: Router) { }

  ngOnInit(): void {}

  ensureArray(possibleArray) {
    if (possibleArray) {
      if (Array.isArray(possibleArray)) {
        return possibleArray;
      } else {
        return [possibleArray];
      }
    } else {
      return [];
    }
  }

  parseIt(stuff) {

    return JSON.parse(stuff);
  }

  async gotoPost(slug) {

    this.router.navigateByUrl('/notice-board/post/' + slug);

  }

  fetchPostsByTag(tag) {

    this.router.navigateByUrl('/notice-board?tag=' + tag);

  }

}
